import { ReactNode } from 'react';
import { PlacesType, VariantType } from 'react-tooltip';

import Icon from '@components/icon/Icon';
import Tooltip from '@components/tooltip/Tooltip';

import theme from '../../../themes/colors';

interface InfoIconTooltipProps {
  id: string;
  tooltipText?: string;
  classname?: string;
  iconClassName?: string;
  children?: ReactNode;
  place?: PlacesType;
  variant?: VariantType;
  noArrow?: boolean;
}

const InfoIconTooltip = ({
  id,
  tooltipText,
  classname,
  iconClassName,
  children,
  place,
  variant,
  noArrow
}: InfoIconTooltipProps) => (
  <>
    <Icon
      name="alert-circle"
      className={`text-grey40 ${iconClassName || ''}`}
      stroke={theme.subText}
      data-tooltip-id={`${id}-info-icon`}
    />
    <Tooltip
      id={`${id}-info-icon`}
      variant={variant}
      type={tooltipText ? 'text' : 'custom'}
      tooltipText={tooltipText}
      className={`leading-5 ${classname || ''}`}
      place={place}
      noArrow={noArrow}
    >
      {children}
    </Tooltip>
  </>
);

export default InfoIconTooltip;
